module.exports = __webpack_public_path__ + "static/media/12(3).3ab49ba0.jpg";